"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = require("styled-components");
var _types = require("./types");
var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var primary = function primary($variantType) {
  switch ($variantType) {
    case _types.InputVariantTypes.Default:
      return (0, _styledComponents.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                background-color: white;\n            "], ["\n                background-color: white;\n            "])));
  }
};
var variants = {
  primary: primary
};
var _default = variants;
exports.default = _default;
var templateObject_1;